module.exports = __webpack_public_path__ + "img/EnerCube2.59baa09b.png";